const API_BASE_URL = process.env.REACT_APP_API_URL || '';

const buildUrl = (endpoint) => `${API_BASE_URL}${endpoint}`;

const handleResponse = async (response) => {
  if (!response.ok) {
    const raw = await response.text();
    let message = raw;
    try {
      message = JSON.parse(raw)?.message || raw;
    } catch {
      // réponse non-JSON, on garde le texte brut
    }
    throw new Error(message || 'Une erreur est survenue');
  }
  if (response.status === 204) {
    return null;
  }
  return response.json();
};

const request = (endpoint, options = {}) =>
  fetch(buildUrl(endpoint), {
    credentials: 'include',
    ...options,
    headers: options.body instanceof FormData ? options.headers : { 'Content-Type': 'application/json', ...options.headers }
  }).then(handleResponse);

// --- Auth ---
export const adminLogin = (password) => request('/api/admin/login', { method: 'POST', body: JSON.stringify({ password }) });
export const adminLogout = () => request('/api/admin/logout', { method: 'POST' });
export const adminSession = () => request('/api/admin/session');
export const fetchAnalytics = () => request('/api/admin/analytics');
export const translateText = (text, source = 'fr', target = 'en') =>
  request('/api/admin/translate', { method: 'POST', body: JSON.stringify({ text, source, target }) });

// --- Upload ---
export const uploadImage = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return request('/api/upload', { method: 'POST', body: formData });
};

export const fetchUploads = () => request('/api/uploads');
export const deleteUpload = (id) => request(`/api/uploads/${id}`, { method: 'DELETE' });
export const renameUpload = (id, originalName) =>
  request(`/api/uploads/${id}`, { method: 'PUT', body: JSON.stringify({ originalName }) });

// --- Translations ---
export const updateTranslations = (lang, payload) =>
  request(`/api/translations/${lang}`, { method: 'PUT', body: JSON.stringify(payload) });

// --- Technologies ---
export const createTechnology = (payload) => request('/api/technologies', { method: 'POST', body: JSON.stringify(payload) });
export const updateTechnology = (id, payload) => request(`/api/technologies/${id}`, { method: 'PUT', body: JSON.stringify(payload) });
export const deleteTechnology = (id) => request(`/api/technologies/${id}`, { method: 'DELETE' });
export const createTechnologyCategory = (payload) => request('/api/technologies/categories', { method: 'POST', body: JSON.stringify(payload) });
export const updateTechnologyCategory = (id, payload) => request(`/api/technologies/categories/${id}`, { method: 'PUT', body: JSON.stringify(payload) });
export const deleteTechnologyCategory = (id) => request(`/api/technologies/categories/${id}`, { method: 'DELETE' });
export const reorderTechnologyCategories = (ids) => request('/api/technologies/categories/reorder', { method: 'PUT', body: JSON.stringify({ ids }) });
export const fetchTechnologyUsage = (id) => request(`/api/technologies/${id}/projects`);
export const linkTechnologyProject = (id, projectId) => request(`/api/technologies/${id}/projects/${projectId}`, { method: 'POST' });
export const unlinkTechnologyProject = (id, projectId) => request(`/api/technologies/${id}/projects/${projectId}`, { method: 'DELETE' });

// --- Projects ---
export const createProject = (payload) => request('/api/projects', { method: 'POST', body: JSON.stringify(payload) });
export const updateProject = (id, payload) => request(`/api/projects/${id}`, { method: 'PUT', body: JSON.stringify(payload) });
export const deleteProject = (id) => request(`/api/projects/${id}`, { method: 'DELETE' });
export const quickCreateProject = (payload) => request('/api/projects/quick', { method: 'POST', body: JSON.stringify(payload) });
export const reorderProjects = (ids) => request('/api/projects/reorder', { method: 'PUT', body: JSON.stringify({ ids }) });
export const createProjectCategory = (payload) => request('/api/projects/categories', { method: 'POST', body: JSON.stringify(payload) });
export const updateProjectCategory = (id, payload) => request(`/api/projects/categories/${id}`, { method: 'PUT', body: JSON.stringify(payload) });
export const deleteProjectCategory = (id) => request(`/api/projects/categories/${id}`, { method: 'DELETE' });
export const setDefaultProjectCategory = (id) => request(`/api/projects/categories/${id}/default`, { method: 'PUT' });
export const reorderProjectCategories = (ids) => request('/api/projects/categories/reorder', { method: 'PUT', body: JSON.stringify({ ids }) });
export const setProjectHomeCover = (id, image) => request(`/api/projects/${id}/home-cover`, { method: 'PUT', body: JSON.stringify({ image }) });
export const reorderHomeCarousel = (ids) => request('/api/projects/carousel/reorder', { method: 'PUT', body: JSON.stringify({ ids }) });

// --- Formations ---
export const createFormation = (payload) => request('/api/formations', { method: 'POST', body: JSON.stringify(payload) });
export const updateFormation = (id, payload) => request(`/api/formations/${id}`, { method: 'PUT', body: JSON.stringify(payload) });
export const deleteFormation = (id) => request(`/api/formations/${id}`, { method: 'DELETE' });

// --- Experiences ---
export const createExperience = (payload) => request('/api/experiences', { method: 'POST', body: JSON.stringify(payload) });
export const updateExperience = (id, payload) => request(`/api/experiences/${id}`, { method: 'PUT', body: JSON.stringify(payload) });
export const deleteExperience = (id) => request(`/api/experiences/${id}`, { method: 'DELETE' });
